"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7122,7091,2672],{

/***/ 674964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Arrow; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);



function Arrow(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512.002 512.002"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M388.425 241.951L151.609 5.79c-7.759-7.733-20.321-7.72-28.067.04-7.74 7.759-7.72 20.328.04 28.067l222.72 222.105-222.728 222.104c-7.759 7.74-7.779 20.301-.04 28.061a19.8 19.8 0 0014.057 5.835 19.79 19.79 0 0014.017-5.795l236.817-236.155c3.737-3.718 5.834-8.778 5.834-14.05s-2.103-10.326-5.834-14.051z",
            fill: props.color
        })
    }));
}


/***/ }),

/***/ 273174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ HeaderArrow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

var HeaderArrow = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "7.561",
        height: props.height || "4.427",
        viewBox: "0 0 7.561 4.427",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            id: "Path_296380",
            fill: props.color || "#000",
            "data-name": "Path 296380",
            d: "M145.574,181.8l-3.166-3.166a.633.633,0,0,0-.893,0L138.35,181.8a.633.633,0,0,0,.893.893l2.716-2.716,2.722,2.716a.631.631,0,1,0,.893-.893Z",
            transform: "translate(-138.197 -178.446)"
        })
    });
};


/***/ }),

/***/ 452882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ HeaderHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

var HeaderHome = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "16.983",
        height: props.height || "16.984",
        viewBox: "0 0 16.983 16.984",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            id: "home",
            fill: props.color || "#000",
            d: "M17.026,7.387h0L10.1.458a1.563,1.563,0,0,0-2.211,0L.961,7.383.954,7.39a1.563,1.563,0,0,0,1.04,2.664l.048,0h.276v5.1a1.832,1.832,0,0,0,1.83,1.83H6.859a.5.5,0,0,0,.5-.5v-4a.836.836,0,0,1,.835-.835h1.6a.836.836,0,0,1,.835.835v4a.5.5,0,0,0,.5.5h2.711a1.832,1.832,0,0,0,1.83-1.83v-5.1h.256a1.564,1.564,0,0,0,1.107-2.669Zm-.7,1.507a.565.565,0,0,1-.4.167h-.754a.5.5,0,0,0-.5.5v5.6a.836.836,0,0,1-.835.835H11.62v-3.5a1.832,1.832,0,0,0-1.83-1.83h-1.6a1.832,1.832,0,0,0-1.83,1.83v3.5H4.148a.836.836,0,0,1-.835-.835v-5.6a.5.5,0,0,0-.5-.5H2.052a.568.568,0,0,1-.391-.97h0L8.589,1.162a.568.568,0,0,1,.8,0l6.926,6.926,0,0A.57.57,0,0,1,16.321,8.894Zm0,0",
            transform: "translate(-0.499)"
        })
    });
};


/***/ }),

/***/ 566974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ OrderIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);



function OrderIcon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: props.size || 23.374,
        height: props.size || 23.374,
        viewBox: "0 0 23.374 23.374"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M0 0h23.374v23.374H0z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M22.707 10.209l-2.294-4a.649.649 0 00-.339-.287l-8.093-2.97a.651.651 0 00-.444 0L3.306 5.916a.65.65 0 00-.344.288l-2.294 4a.651.651 0 00.329.93l1.879.729v4.976a.651.651 0 00.43.612l8.17 2.942a.647.647 0 00.274.061h.009a.651.651 0 00.221-.038l8.231-2.964a.651.651 0 00.43-.612v-5.027l1.737-.674a.651.651 0 00.329-.93zM11.756 4.252l6.2 2.274-6.213 2.286-6.302-2.281zM3.819 7.327l6.976 2.525-1.75 3.012-6.872-2.665zm.362 5.046l4.912 1.909a.65.65 0 00.8-.28l1.207-2.078v6.956l-6.919-2.493zm15.163 4.014l-6.94 2.5v-6.85l1.077 1.952a.651.651 0 00.805.292l5.058-1.963zm-5-3.525l-1.657-3 6.873-2.528 1.644 2.87z",
                fill: props.secondaryColor || "#000"
            })
        ]
    }));
}


/***/ }),

/***/ 970870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ WhatsAppIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);



function WhatsAppIcon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: props.size || 34.886,
        height: props.size || 34.886,
        viewBox: "0 0 34.886 34.886"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M0 0h34.886v34.886H0z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.444 30.611h-.029a13.41 13.41 0 01-7.207-2.121l-4.991 1.3 1.338-4.851-.318-.5a13.134 13.134 0 01-2.018-7c0-11.7 14.3-17.554 22.575-9.283 8.256 8.179 2.46 22.455-9.35 22.455z",
                fill: "#1e9848",
                stroke: "#fff",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M24.684 20.702l-.012.1c-.4-.2-2.352-1.154-2.715-1.286-.816-.3-.586-.048-2.152 1.746-.233.26-.464.279-.86.1a10.8 10.8 0 01-3.2-1.976 12.074 12.074 0 01-2.209-2.755c-.39-.673.426-.769 1.168-2.175a.732.732 0 00-.033-.7c-.1-.2-.894-2.156-1.227-2.936s-.648-.679-.894-.679a1.981 1.981 0 00-1.821.458c-2.148 2.361-1.606 4.8.232 7.386 3.612 4.727 5.536 5.6 9.055 6.806a5.506 5.506 0 002.5.161 4.1 4.1 0 002.683-1.9 3.294 3.294 0 00.24-1.9c-.1-.18-.359-.279-.759-.459z",
                fill: "#fff"
            })
        ]
    }));
}


/***/ }),

/***/ 57091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _index_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(979021);
/* harmony import */ var _assets_svgExports_WhatsAppIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(970870);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(667294);
/* harmony import */ var _utils_whatsappMessageRender__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(472579);
/* harmony import */ var src_hooks_useStoreContactDetails__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(299375);
/**
 * This is a reusable component for whatsapp functionality
 * desktop views of multiple headers
 */ 





var WhatsAppIconComp = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), showWANo = ref[0], setShowWANo = ref[1];
    var storePhone = (0,src_hooks_useStoreContactDetails__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().storePhone;
    var onContactBtnClick = function() {
        (0,_utils_whatsappMessageRender__WEBPACK_IMPORTED_MODULE_4__/* .whatsappMessageRender */ .L)();
    };
    return !!storePhone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_index_styles__WEBPACK_IMPORTED_MODULE_1__/* .MenuItem */ .sN, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_WhatsAppIcon__WEBPACK_IMPORTED_MODULE_2__/* .WhatsAppIcon */ .y, {
                onClick: function() {
                    return setShowWANo(!showWANo);
                },
                size: "24"
            }),
            !!storePhone && showWANo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_index_styles__WEBPACK_IMPORTED_MODULE_1__/* .WaNoDp */ .xx, {
                onClick: onContactBtnClick,
                children: storePhone
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (WhatsAppIconComp);


/***/ }),

/***/ 634098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* reexport safe */ _mobileIcon__WEBPACK_IMPORTED_MODULE_1__["default"]; },
/* harmony export */   "u": function() { return /* reexport safe */ _desktopIcon__WEBPACK_IMPORTED_MODULE_0__["default"]; }
/* harmony export */ });
/* harmony import */ var _desktopIcon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57091);
/* harmony import */ var _mobileIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(622672);





/***/ }),

/***/ 979021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cy": function() { return /* binding */ HeaderSectionListItem; },
/* harmony export */   "sN": function() { return /* binding */ MenuItem; },
/* harmony export */   "xx": function() { return /* binding */ WaNoDp; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(307297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(150066);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: ",
        ";\n  display: flex;\n  align-items: center;\n  flex: 0 0 auto;\n  color: ",
        ";\n  position: relative;\n  cursor: pointer;\n\n  @media screen and (min-width: 767px) {\n    font-size: 18px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 15px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 7px 13px;\n  font-size: 15px;\n  color: #101010;\n  box-shadow: 0px 3px 6px #00000029;\n  background: #ffffff 0% 0% no-repeat padding-box;\n  position: absolute;\n  top: 40px;\n  left: 50%;\n  transform: translateX(-50%);\n  cursor: pointer;\n\n  &::before {\n    content: '';\n    top: -10px;\n    left: 50%;\n    transform: translateX(-50%);\n    position: absolute;\n    border-bottom: 10px solid #ffffff;\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  font-size: 15px;\n  align-items: center;\n\n  & > p {\n    margin-left: 10px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var MenuItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "MenuItem",
    componentId: "sc-d21082bf-0"
})(_templateObject(), function(props) {
    return props.margin || "0 0 0 20px";
}, function(props) {
    return props.secondaryColor;
});
var WaNoDp = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "WaNoDp",
    componentId: "sc-d21082bf-1"
})(_templateObject1());
var HeaderSectionListItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "HeaderSectionListItem",
    componentId: "sc-d21082bf-2"
})(_templateObject2());


/***/ }),

/***/ 622672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _utils_whatsappMessageRender__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(472579);
/* harmony import */ var _assets_svgExports_WhatsAppIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(970870);
/* harmony import */ var _index_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(979021);
/* harmony import */ var src_hooks_useStoreContactDetails__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(299375);
/**
 * This is a reusable component for whatsapp functionality
 * mobile views of multiple headers
 */ 




var MobileWhatsAppComp = function(props) {
    var storePhone = (0,src_hooks_useStoreContactDetails__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().storePhone;
    var onContactBtnClick = function() {
        (0,_utils_whatsappMessageRender__WEBPACK_IMPORTED_MODULE_1__/* .whatsappMessageRender */ .L)();
    };
    return !!storePhone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_index_styles__WEBPACK_IMPORTED_MODULE_3__/* .HeaderSectionListItem */ .cy, {
        onClick: onContactBtnClick,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_WhatsAppIcon__WEBPACK_IMPORTED_MODULE_2__/* .WhatsAppIcon */ .y, {
                size: 24
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_index_styles__WEBPACK_IMPORTED_MODULE_3__/* .MenuItem */ .sN, {
                secondaryColor: props.secondaryColor || "#000000",
                children: "Contact on WhatsApp"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MobileWhatsAppComp);


/***/ }),

/***/ 155039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _assets_svgExports_WishlistHeartIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(407056);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(225617);
/* harmony import */ var _constants_wishlist__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(298627);
/* harmony import */ var src_hooks_useFeatureLocks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(482516);





var WishlistIcon = function(param) {
    var color = param.color, iconSize = param.iconSize, isActive = param.isActive;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_WishlistHeartIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        color: color,
        iconSize: iconSize,
        isActive: isActive
    });
};
var WishlistText = function(param) {
    var _customTextClassName = param.customTextClassName, customTextClassName = _customTextClassName === void 0 ? "" : _customTextClassName, _ctaText = param.ctaText, ctaText = _ctaText === void 0 ? "Wishlist" : _ctaText;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "tw-font-inter tw-text-[17px] tw-font-normal ".concat(customTextClassName),
        children: ctaText
    });
};
var WishlistBoth = function(param) {
    var color = param.color, iconPosition = param.iconPosition, iconSize = param.iconSize, wrapperClassName = param.wrapperClassName, _customTextClassName = param.customTextClassName, customTextClassName = _customTextClassName === void 0 ? "" : _customTextClassName, ctaText = param.ctaText, isActive = param.isActive;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "tw-flex tw-gap-[10px] tw-items-center ".concat(wrapperClassName),
        children: iconPosition === "right" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistText, {
                    customTextClassName: customTextClassName,
                    ctaText: ctaText
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistIcon, {
                    color: color,
                    iconSize: iconSize,
                    isActive: isActive
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistIcon, {
                    color: color,
                    iconSize: iconSize,
                    isActive: isActive
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistText, {
                    customTextClassName: customTextClassName,
                    ctaText: ctaText
                })
            ]
        })
    });
};
var WishlistHeaderMenuItem = function(param) {
    var color = param.color, iconSize = param.iconSize, _iconPosition = param.iconPosition, iconPosition = _iconPosition === void 0 ? "right" : _iconPosition, _showComponent = param.showComponent, showComponent = _showComponent === void 0 ? "both" : _showComponent, _customTextClassName = param.customTextClassName, customTextClassName = _customTextClassName === void 0 ? "" : _customTextClassName, _wrapperClassName = param.wrapperClassName, wrapperClassName = _wrapperClassName === void 0 ? "" : _wrapperClassName, ctaText = param.ctaText, isActive = param.isActive, onClick = param.onClick;
    var wishlistFeatureActive = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        var ref, ref1, ref2;
        return {
            wishlistFeatureActive: (ref = state.storeReducer) === null || ref === void 0 ? void 0 : (ref1 = ref.store) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.services) === null || ref2 === void 0 ? void 0 : ref2.wishlist_flag
        };
    }).wishlistFeatureActive;
    var wishlistFeatureStatus = (0,src_hooks_useFeatureLocks__WEBPACK_IMPORTED_MODULE_4__/* .useFeatureLocks */ .r)().wishlistFeatureStatus;
    if (wishlistFeatureActive !== _constants_wishlist__WEBPACK_IMPORTED_MODULE_3__/* .WISHLIST_FEATURE_STATUS.WISHLIST_ACTIVE */ .g.WISHLIST_ACTIVE || (wishlistFeatureStatus === null || wishlistFeatureStatus === void 0 ? void 0 : wishlistFeatureStatus.isLocked)) {
        return null;
    }
    if (showComponent === "icon") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        onClick: onClick,
        style: {
            cursor: onClick ? "pointer" : undefined
        },
        className: "tw-flex tw-items-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistIcon, {
            color: color,
            iconSize: iconSize,
            isActive: isActive
        })
    });
    if (showComponent === "text") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        onClick: onClick,
        style: {
            cursor: onClick ? "pointer" : undefined
        },
        className: "tw-flex tw-items-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistText, {
            customTextClassName: customTextClassName,
            ctaText: ctaText
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        onClick: onClick,
        style: {
            cursor: onClick ? "pointer" : undefined
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistBoth, {
            color: color,
            iconPosition: iconPosition,
            iconSize: iconSize,
            wrapperClassName: wrapperClassName,
            customTextClassName: customTextClassName,
            ctaText: ctaText,
            isActive: isActive
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WishlistHeaderMenuItem);


/***/ }),

/***/ 220949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _checkIfThemePreview__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(115483);
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(506337);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(913886);
/* harmony import */ var _getUrlParams__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(705492);




var checkIfShowDummyProduts = function(storeData) {
    var isPreview = (0,_checkIfThemePreview__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    var isPremium = !!storeData.premium;
    var items_available = (!_checkRenderEnv__WEBPACK_IMPORTED_MODULE_1__/* .IS_SERVER */ .W6 && (0,_getUrlParams__WEBPACK_IMPORTED_MODULE_3__/* .getUrlParams */ .D)([
        _constants__WEBPACK_IMPORTED_MODULE_2__/* .PREVIEW_PARAMS.ITEMS_AVAILABLE */ .I.ITEMS_AVAILABLE
    ])).items_available;
    var isItemsAvailable = +items_available;
    return isPreview && (!isPremium || !isItemsAvailable);
};
/* harmony default export */ __webpack_exports__["Z"] = (checkIfShowDummyProduts);


/***/ }),

/***/ 168491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _checkIfShowDummyProducts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(220949);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(913886);


/**
 * function to get store logo in case of dummy or actual data
 * @param storeInfo
 * @returns
 */ var getActualOrDsStoreLogo = function(storeInfo) {
    var ref;
    var showDummyData = (0,_checkIfShowDummyProducts__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(storeInfo);
    return (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.logo_image) || (showDummyData ? _constants__WEBPACK_IMPORTED_MODULE_1__/* .DS_LOGO_IMAGE_URL */ .pP : null);
};
/* harmony default export */ __webpack_exports__["Z"] = (getActualOrDsStoreLogo);


/***/ }),

/***/ 704956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p6": function() { return /* binding */ showMyAccount; }
/* harmony export */ });
/* unused harmony export isUserLoggedIn */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(629815);
/* harmony import */ var _checkClientDeviceType__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(313508);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17247);
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(506337);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(540190);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(913886);






var isUserLoggedIn = function() {
    var ref;
    return !!((ref = _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .Z.getState().userReducer) === null || ref === void 0 ? void 0 : ref.isLogin);
};
var showMyAccount = function() {
    return !_checkRenderEnv__WEBPACK_IMPORTED_MODULE_2__/* .IS_SERVER */ .W6 && _checkClientDeviceType__WEBPACK_IMPORTED_MODULE_0__/* .IS_MOBILE */ .q$ && _checkRenderEnv__WEBPACK_IMPORTED_MODULE_2__/* .IS_WEBVIEW */ .x5 && isUserLoggedIn();
};
var myAccountNavData = {
    page_name: "My Account",
    slug_url: _routes__WEBPACK_IMPORTED_MODULE_3__.PATH.MY_ACCOUNT,
    page_type: "my-account"
};
var getNavList = function(navigationItems) {
    var visibleItemsLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _constants__WEBPACK_IMPORTED_MODULE_4__/* .MAX_VISIBLE_NAV_LINKS */ .Ow, showCategories = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var subNavObj = {
        page_type: "subNavList",
        subNavs: [],
        is_editable: false,
        page_id: "616d2bd6152384798123d775",
        page_name: showCategories ? "Categories" : "More",
        slug_url: showCategories ? "more" : "subNavList"
    };
    var showMyAccountSection = showMyAccount();
    if ((navigationItems === null || navigationItems === void 0 ? void 0 : navigationItems.length) > 0) {
        var tempNavList = [];
        if (showCategories) {
            tempNavList = navigationItems.filter(function(nav) {
                return nav.page_type !== "shop";
            });
        } else {
            tempNavList = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(navigationItems);
        }
        if ((navigationItems === null || navigationItems === void 0 ? void 0 : navigationItems.length) > visibleItemsLength) {
            var extractedNavList = tempNavList.splice(visibleItemsLength, tempNavList.length);
            subNavObj.subNavs = extractedNavList;
            if (showMyAccountSection) {
                subNavObj.subNavs.push(myAccountNavData);
            }
            var newNavList = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(tempNavList).concat([
                subNavObj
            ]);
            return newNavList;
        } else {
            if (showMyAccountSection) {
                subNavObj.subNavs.push(myAccountNavData);
                tempNavList.push(subNavObj);
            }
            return tempNavList;
        }
    }
    return [];
};
/* harmony default export */ __webpack_exports__["ZP"] = (getNavList);


/***/ }),

/***/ 853569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ commonOutsideClick; },
/* harmony export */   "W": function() { return /* binding */ isOutsideClick; }
/* harmony export */ });
var isOutsideClick = function(parentRef, target) {
    var ref;
    if ((ref = parentRef.current) === null || ref === void 0 ? void 0 : ref.contains(target)) return true;
    return false;
};
var commonOutsideClick = function(param) {
    var event = param.event, _pathNo = param.pathNo, pathNo = _pathNo === void 0 ? 0 : _pathNo, ref = param.ref, callback = param.callback;
    var path = event.path || event.composedPath && event.composedPath();
    if (!isOutsideClick(ref, path[pathNo])) {
        callback && callback();
    }
};


/***/ }),

/***/ 273494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ getVisibilityForFooter; },
/* harmony export */   "g": function() { return /* binding */ getVisibilityForHeader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(629815);
// the status defines the visibility of logo or name with respect to header and footer

var STATUS_DISABLED = 0;
var STATUS_SHOW_ON_HEADER = 1;
var STATUS_SHOW_ON_FOOTER = 2;
var STATUS_SHOW_ON_HEADER_FOOTER = 3;
// const STATUS_DONT_SHOW_ON_HEADER_FOOTER = 4;
var COMMON_STATUS_SHOW = [
    STATUS_DISABLED,
    STATUS_SHOW_ON_HEADER_FOOTER
];
function getVisibilityForHeader(status) {
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(COMMON_STATUS_SHOW).concat([
        STATUS_SHOW_ON_HEADER
    ]).includes(status);
}
function getVisibilityForFooter(status) {
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(COMMON_STATUS_SHOW).concat([
        STATUS_SHOW_ON_FOOTER
    ]).includes(status);
}


/***/ }),

/***/ 472579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ whatsappMessageRender; }
/* harmony export */ });
/* harmony import */ var _getWhatsAppRedirectionUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(230066);

/**
 * common function to open whatsapp for messaging the store owner
 * display/registered number
 * @param {Object} - userData, phoneNumber, storeUrl
 */ var whatsappMessageRender = function() {
    (0,_getWhatsAppRedirectionUrl__WEBPACK_IMPORTED_MODULE_0__/* .openWhatsAppLeadModal */ .iM)();
};


/***/ })

}]);